import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-timer-flash-line"></i>
              实时追更
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最近更新
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              最新话第一时间同步上线
            </p>
          </div>
          <a
            href="#updates"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium mt-3 md:mt-0 cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          <div className="divide-y divide-background-200/50">
            {updates.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <div className="flex-1 min-w-0 flex items-center gap-3">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-read-line text-foreground-400 text-lg"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                        {item.title}
                      </h3>
                      {item.tag === 'hot' && (
                        <span className="px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-600 text-[10px] font-medium whitespace-nowrap">
                          热门
                        </span>
                      )}
                      {item.tag === 'new' && (
                        <span className="px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-600 text-[10px] font-medium whitespace-nowrap">
                          新番
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {item.chapter}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <span className="w-8 h-8 rounded-full bg-primary-50 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors flex-shrink-0">
                    <i className="ri-bookmark-line text-primary-500 text-sm"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}